import React, {useState, useCallback, useEffect} from 'react';
import {Row, Col, Layout, Menu, Breadcrumb, Select, Input} from 'antd';

const {SubMenu} = Menu;
import DocumentMeta from 'react-document-meta';
import intl from 'react-intl-universal';
import {bindActionCreators} from 'redux';
import {useSelector, useDispatch} from 'react-redux';
import {get} from 'lodash';
import {useHistory, useRouteMatch} from 'react-router';
import {languages} from '@/constants';
import Header from '@/components/Header/index';
import Footer from '@/components/Footer/index';
import * as actions from '@/store/actions';
import './style.scss';
import {string} from '@/utils/string';
import {AppstoreOutlined, UserOutlined, UploadOutlined, ArrowLeftOutlined} from '@ant-design/icons';
import {isAuthorLogin} from '@/utils/author';
import cookie from "react-cookies";
import {message} from "antd/lib/index";

const {Sider, Content} = Layout;
const {Option} = Select;
const {Search} = Input;

//判断菜单
var leftMenuKey = ['1']
var pathname = window.location.pathname;
if (pathname.indexOf('/author/book') !== -1) {
  leftMenuKey = ['3']
}

if (pathname.indexOf('/author/person') !== -1) {
  leftMenuKey = ['2']
}

function onLeftMenu(e){
  switch (e.key){
    case '2':
      location.href='/author/person'
      break;
    case '3':
      location.href='/author/book/lists'
      break;
    case '4':
      cookie.remove('authortoken', {path: '/'})
      cookie.remove('authorid', {path: '/'})
      cookie.remove('authornickname', {path: '/'})
      cookie.remove('authoravatar', {path: '/'})
      message.success('退出成功！').then(() => {
        location.href = '/'
      })
  }
}


function generateNavMenus() {
  return [{
    displayName: "书苑首页",
    link: '/',
    reg: /^/
  }, {
    displayName: '书库',
    link: '/classify',
    reg: /^/
  }, {
    displayName: '我的书架',
    link: '/readlog',
    reg: /^/
  }, {
    displayName: '作家专区',
    link: '/author',
    reg: /^/
  }];
}

const meta = {
  title: '蜜阅书苑_华语言情阅读品牌',
  description: '蜜阅书苑是国内新一线言情小说阅读网站，行业领先的泛言情IP孵化平台。提供总裁小说、现代言情、古代言情、悬疑灵异等热门小说免费阅读，最火最新的言情小说大全，尽在，尽在www.mixs.cn',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '蜜阅书苑,蜜阅,言情小说,小说阅读网,阅读阁'
    }
  }
};


const AuthorLayout = (props) => {
  const {children, className, searchFocus, readParam, isFooterShow} = props;
  const history = useHistory();
  const match = useRouteMatch();
  const [navMenus, setNavMenus] = useState([]);
  const menuSelectedKeys = [get(navMenus.find((menu) => menu.reg.test(match.path)), 'link')].filter(Boolean);
  const {userInfo, language} = useSelector((state) => ({
    userInfo: state.global.userInfo,
    language: state.global.language
  }));
  const onMenuClick = ({key}) => {
    history.push(key);
  }
  //监听语言变化
  useEffect(() => {
    setNavMenus(generateNavMenus());
  }, [language])
  const renderUserInfoPanel = useCallback(() => {
    const {changeSystemLanguage} = bindActionCreators(actions, useDispatch());
    const {username, email} = userInfo;
    return <div className="user-info-panel">
      <div className="basic-info">
        <div>
          <Avatar src={require('@/assets/avtar.jpeg')} size={38}/>
        </div>
        <div style={{paddingLeft: 16}}>
          <div>{username}</div>
          <div>{email}</div>
        </div>
      </div>
      <ul className="action-menu">
        <li>
          <Icon type="diff"/>
          <span> {intl.get('Action.ChangeLanguage')}</span>
          <Select value={language} placeholder="请选择" style={{width: 100, float: 'right'}} size="small"
                  onChange={changeSystemLanguage}>
            {
              languages.map((lang) => <Option key={lang.value} value={lang.value}>{lang.label}</Option>)
            }
          </Select>
        </li>
        <li><Icon type="logout"/><span> {intl.get('Action.Logout')}</span></li>
      </ul>
    </div>
  }, [userInfo, language])

  return (
    <DocumentMeta {...meta}>
      <Layout className="g-container">
        <div style={{'width': '100%'}} className={'readBg' + (!string.isNull(readParam) ? readParam.bgColorIndex : 0)}>
          <Header/>
        </div>
        <Layout className="g-body bg-white margin-b-20">
          <div class="w1200 margin-center margin-t-20">
            <Row>
              <Col span={5}>
                <Sider className={`g-nav g-section-bg border-primary bg-white h100`} width={230}>
                  <Menu theme="light" className={`bg-white`} mode="inline" defaultSelectedKeys={leftMenuKey} onClick={onLeftMenu.bind(this)}>
                    <Menu.Item key="2" icon={<UserOutlined/>}>
                      作者资料
                    </Menu.Item>
                    <Menu.Item key="3" icon={<UploadOutlined/>}>
                      作品管理
                    </Menu.Item>
                    <Menu.Item key="4" icon={<ArrowLeftOutlined/>}>
                      退出
                    </Menu.Item>
                  </Menu>
                </Sider>
              </Col>
              <Col span={19} className={`padded-b-20 border-primary`}>
                <Content class="g-content">{children}</Content>
              </Col>
            </Row>
          </div>
        </Layout>
        {string.isNull(isFooterShow) ?
          <Footer/>
          : ''}
      </Layout>
    </DocumentMeta>
  )
}

export default AuthorLayout;
